import React from 'react';
import { GlobeAmericasIcon } from '@heroicons/react/20/solid';
import { Button } from '@/components/buttons/Button';
import { useIntl } from 'react-intl';
import CloseButton from '@/components/UI/Buttons/CloseButton';
import LocationCheckLoading from '../../../../assets/LocationCheckLoading';

const LocationCheckProgress = ({
  onClick,
  closeModalOnClick,
}: {
  closeModalOnClick: () => void;
  onClick: () => void;
}) => {
  const intl = useIntl();
  return (
    <div className="w-full xs:max-w-[400px] md:max-w-[420px] rounded-xl bg-white relative">
      <CloseButton onClick={closeModalOnClick} />
      <div className="flex flex-col justify-center items-center px-8 py-8 gap-y-8">
        <div className="relative">
          <GlobeAmericasIcon
            height={45}
            width={45}
            className="mx-auto fill-green-500 stroke-blue-800"
          />
          <LocationCheckLoading />
        </div>
        <div className="text-center">
          <h4 className="m-0 p-0">{intl.formatMessage({ id: 'geo-location.progress.header' })}</h4>
          <p className="m-0 mt-3 p-0 leading-snug">
            {intl.formatMessage({ id: 'geo-location.progress.description' })}
          </p>
        </div>
        <Button
          onClickHandler={onClick}
          text={intl.formatMessage({ id: 'registration.ontario.accountBlocked.cta' })}
        />
      </div>
    </div>
  );
};

export default LocationCheckProgress;
